import { useContext } from "react";
import { KycEventContext } from "../contexts/KycEventContext";

export const useKycEvent = () => useContext(KycEventContext);
